var _rect, _rect2, _rect3, _rect4, _rect5, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloneSeqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 64,
    viewBox: "0 0 48 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39.4849,
    y: 19.7891,
    width: 3.75758,
    height: 31.9394,
    transform: "rotate(90 39.4849 19.7891)",
    fill: "#1976D2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39.4849,
    y: 34.8164,
    width: 3.75758,
    height: 31.9394,
    transform: "rotate(90 39.4849 34.8164)",
    fill: "#1976D2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39.4849,
    y: 49.8477,
    width: 3.75758,
    height: 31.9394,
    transform: "rotate(90 39.4849 49.8477)",
    fill: "#1976D2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28.2119,
    y: 42.332,
    width: 3.75758,
    height: 20.6667,
    transform: "rotate(90 28.2119 42.332)",
    fill: "#1976D2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 28.2119,
    y: 27.3047,
    width: 3.75758,
    height: 20.6667,
    transform: "rotate(90 28.2119 27.3047)",
    fill: "#1976D2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.0303 1H0.515137V63H47.4848V9.45455M39.0303 1V9.45455H47.4848M39.0303 1L47.4848 9.45455",
    stroke: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloneSeqIcon);
export default __webpack_public_path__ + "static/media/CloneSeqIcon.649cc58799f1ebb92e4240a176535795.svg";
export { ForwardRef as ReactComponent };